<template>
  <el-dialog :visible.sync="visible"
             width="30%"
             title="选择账号类型："
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <div class="aui-wrapper aui-page__login">
      <div class="type-div">
        <div class="each-type"
             @click="registerType='10'"
             :class="registerType=='20' ? 'opacity5':''">
          <div class="icon-div">
            <svg aria-hidden="true"
                 class="icon-svg">
              <use xlink:href="#icon-shop"></use>
            </svg>
          </div>
          <div class="text-div">
            企业账号
          </div>
        </div>
        <div class="each-type"
             @click="registerType='20'"
             :class="registerType=='10' ? 'opacity5':''">
          <div class="icon-div">
            <svg aria-hidden="true"
                 class="icon-svg">
              <use xlink:href="#icon-user"></use>
            </svg>
          </div>
          <div class="text-div">
            个人账号
          </div>

        </div>
      </div>
      <div class="desc-div">
        <div v-if="registerType=='10'">
          <div class="each-div">
            1.快速交易
          </div>
          <div class="each-div">
            2.自由采购
          </div>
          <div class="each-div">
            3.海量工业品
          </div>
          <div class="each-div">
            4.后续可通过认证成为企业账号
          </div>
        </div>
        <div v-else>
          <div class="each-div">
            1.企业账号认证后享企业采购价折扣
          </div>
          <div class="each-div">
            2.企业账号享专属客服服务
          </div>
          <div class="each-div">
            3.企业账号可开具资质发票
          </div>
          <div class="each-div">
            4.企业账号可享联储联备服务
          </div>
        </div>
      </div>
      <div class="top-40">
        <el-button type="primary"
                   @click="dataFormSubmitHandle()"
                   class="w-percent-100">{{ registerType=='10' ? '去注册企业账号':'确认注册个人账号' }}</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="personVisible"
               width="30%"
               append-to-body
               :close-on-click-modal="false"
               title="注册个人帐号">
      <el-form label-position="top"
               class="register-fast-login"
               :model="personDataForm"
               :rules="dataRule"
               ref="personDataForm"
               status-icon>
        <el-form-item label="怎么称呼您？"
                      label-width="100px"
                      prop="name">
          <el-input v-model="personDataForm.name"
                    placeholder="姓名"
                    autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="输入密码"
                      label-width="100px"
                      prop="password">
          <el-input v-model="personDataForm.password"
                    type="password"
                    auto-complete="new-password"
                    placeholder="请输入您的密码"></el-input>
        </el-form-item>
        <el-form-item label="再次确认密码"
                      label-width="100px"
                      prop="rePassword">
          <el-input v-model="personDataForm.rePassword"
                    type="password"
                    auto-complete="new-password"
                    placeholder="请再次输入您的密码"></el-input>
        </el-form-item>
        <el-form-item label="邀请码"
                      label-width="100px"
                      prop="invitationCode">
          <el-input v-model="personDataForm.invitationCode"
                    placeholder="选填"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     @click="personDataFormSubmitHandle()"
                     class="w-percent-100 top-40">完成注册</el-button>
        </el-form-item>
      </el-form>
      <div class="tip">
        您的信息将被严格保密
      </div>
    </el-dialog>
    <el-dialog :visible.sync="enterpriseVisible"
               width="30%"
               append-to-body
               title="注册企业帐号">
      <register-enterprise ref="registerEnterprise">
      </register-enterprise>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
import { messages } from '@/i18n'
import { getUUID } from '@/utils'
import RegisterEnterprise from './register-enterprise'
export default {
  data () {
    return {
      mobile: '', // 用户的手机号
      visible: false,
      personVisible: false,
      enterpriseVisible: false,
      i18nMessages: messages,
      captchaPath: '',
      dataForm: {
        username: '',
        password: '',
        uuid: '',
        captcha: '',
        grant_type: 'password'
      },
      registerType: '10',
      personDataForm: {
        username: '',
        name: '',
        password: '',
        rePassword: '',
        invitationCode: ''
      }
    }
  },
  components: {
    RegisterEnterprise
  },
  computed: {
    dataRule () {
      let validatePassword = (rule, value, callback) => {
        if (value && (value !== this.personDataForm.password)) {
          return callback(new Error('两次密码输入不一致'))
        }
        callback()
      }
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getCaptcha()
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
      })
    },
    // 获取验证码
    getCaptcha () {
      this.dataForm.uuid = getUUID()
      this.captchaPath = `${window.SITE_CONFIG['apiURL']}/auth/captcha?uuid=${this.dataForm.uuid}`
    },
    dataFormSubmitHandle () {
      if (this.registerType === '20') {
        this.personVisible = true
      } else {
        this.enterpriseVisible = true
      }
    },
    // 个人注册
    personDataFormSubmitHandle: debounce(function () {
      this.$refs['personDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let Base64 = require('js-base64').Base64
        this.$http.post(`/front/consumer/user/register`, {
          username: this.mobile,
          name: this.personDataForm.name,
          companyName: '',
          password: Base64.encode(this.personDataForm.password),
          socialCreditCode: '',
          registerType: 1,
          invitationCode: this.personDataForm.invitationCode,
          appCode: 'PLANTMATE_OFFICIAL',
          clientId: 'android'
        })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            Cookies.set('access_token_shop', res.access_token)
            window.SITE_CONFIG['permissions'] = res.permissions || []
            this.$router.replace({ name: 'home' })
            // 注册成功跳转登录页面 刷新当前页面
            // location.reload()
            // 注册
          }).catch(() => {
          })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang="scss" scoped>
.type-div {
  display: flex;
  justify-content: space-around;
  .each-type {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon-div {
      background: #008cf9;
      border-radius: 50%;
      padding: 10px;
      svg {
        font-size: 36px;
        color: #fff;
      }
    }
    .text-div {
      margin-top: 10px;
    }
  }
  .opacity5 {
    opacity: 0.5;
  }
}
.desc-div {
  margin-top: 20px;
  height: 140px;
  border: 1px solid #aaa;
  border-radius: 4px;
  padding: 20px 30px;
  .each-div {
    color: #666;
    font-size: 12px;
    margin-bottom: 10px;
  }
}
.tip {
  color: #666;
  font-size: 12px;
  margin-top: 10px;
}
</style>
<style lang="scss">
.register-fast-login {
  margin-top: -20px;
  .el-form-item__label {
    padding: 0;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
